var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "183.76 64.9 143.96 143.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dd4747;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.82,137.15c0,.74-.34,1.42-.93,1.87l-32.24,24.31c-.64.48-1.39.73-2.19.73-.97,0-1.89-.38-2.58-1.07l-22.72-22.72c-1.86-1.86-1.86-4.89,0-6.75l22.28-22.28c.69-.69,1.6-1.07,2.58-1.07.79,0,1.54.25,2.17.73,7.55,5.64,24.65,18.4,32.69,24.39.59.44.94,1.12.94,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.53,172.88c.05.73-.21,1.41-.72,1.93l-32.68,32.68c-.9.9-2.1,1.4-3.38,1.4s-2.47-.5-3.38-1.4l-33.05-33.05c-.51-.52-.77-1.21-.72-1.93.06-.73.41-1.37.99-1.81l33.06-24.64c.83-.62,1.82-.94,2.86-.94s2.04.33,2.87.96l33.16,25c.58.44.93,1.08.98,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293,101.37c-.05.72-.4,1.35-.98,1.79l-33.59,25.03c-.83.62-1.82.94-2.86.94s-2.04-.33-2.87-.96l-33.21-25.04c-.57-.43-.92-1.07-.97-1.78-.05-.72.21-1.4.71-1.91l33.14-33.14c.9-.9,2.1-1.4,3.38-1.4s2.47.5,3.38,1.4l33.15,33.15c.51.51.77,1.19.71,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.34,140.27l-23.6,23.6c-.42.42-.97.65-1.57.65-.48,0-.94-.15-1.33-.45l-33.54-25.29c-.52-.39-.82-.99-.82-1.64s.3-1.24.82-1.63c7.87-5.87,26.94-20.09,33.99-25.37.38-.29.84-.43,1.32-.43.59,0,1.14.23,1.56.65l23.16,23.16c1.86,1.86,1.86,4.88,0,6.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.a8d257e61aa8f1e2b274ad7199b8a575.svg";
export { ForwardRef as ReactComponent };